import React from 'react';
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { useUser } from './useUser';
import { Company, Period, User } from '../models';
import { SMALL_GET_COMPANY } from '../graphql/queries';

export function useAssignPeriod() {
  const [user] = useUser();
  const router = useRouter();
  const [goalId, setGoalId] = React.useState<string | null>(null);
  const [period, setPeriod] = React.useState<Period | null>(null);
  const [users, setUsers] = React.useState<User[]>([]);

  const { data: dataGetCompany, loading: loadingGetCompany } = useQuery<{
    company: Company;
  }>(SMALL_GET_COMPANY, {
    variables: {
      filter: {
        _id: (user?.company as Company)?._id,
      },
    },
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    if (dataGetCompany) {
      const goalSelected = dataGetCompany?.company?.companyDetails.goals.find(
        (goal) =>
          goal.periods.find((periodItem) => {
            if (periodItem._id === router.query._id) {
              return goal._id;
            }
            return null;
          })
      );

      const periodSelected = goalSelected?.periods.find(
        (periodItem) => periodItem._id === router.query._id
      );
      setGoalId(goalSelected?._id);
      setPeriod(periodSelected);
    }
  }, [dataGetCompany]);

  return {
    dataGetCompany,
    loadingGetCompany,
    goalId,
    setGoalId,
    period,
    setPeriod,
    users,
    setUsers,
  };
}
